
import { Container, Button, Grid, Link, makeStyles,  CssBaseline, FormControl, Input, InputLabel, InputAdornment, IconButton } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import React, { useEffect, useState, KeyboardEvent } from 'react'
import axios, { AxiosRequestConfig } from 'axios';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { ILogin, IServiceUserContent } from '../../datasolvr/ServicesFacade';
import { Logo } from '../../components/ui/Logo';
import toast from 'react-hot-toast';
import { icon_backButton } from '../../assets/images/images';
import { IResetPasswordUser } from '../../interface/interface';
import { planEatApi } from '../../planEatApi/PlanEatApi';
import { extractErrorMessage } from '../../components/utils/ErrorHandler';


const useStyles = makeStyles((theme: any) => ({
    topbarContainer: {
        padding: 10,
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    paper: {
        marginTop: '10%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    inputFieldContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginTop: 15
    },
    loginContainer: {
        marginTop: '6%',
        color: '#999999'
    },
    title: {
        marginTop: '2%',
        marginBottom: '5%',
        fontSize: 20,
        fontWeight: 700
    },
    sendEmailButton: {
        color: 'white',
        fontSize: 12,
        padding: 10,
        fontWeight: 700,
        letterSpacing: 2,
        marginTop: 30
    },
}));

export const ResetPassword: React.FC = () => {
    // Styling 
    const classes = useStyles();

    // Routing
    let history = useHistory();
    const { token } = useParams<{ token?: string }>();

    // State
    const [resetPasswordUser, setResetPasswordUser] = React.useState<IResetPasswordUser>({
        newPassword: '',
        confirmNewPassword: '',
        showPassword: false
    });

    useEffect(() => {
        if (token) {
            localStorage.setItem('token', token);
        }
    }, [token])

    const postToken = () => {
        token && planEatApi.postToken(token).then((response) => {
            getUser(response.data.userId);
        }).catch((response) => {
            console.log(response);
        })
    }

    const getUser = (userId: string) => {
        planEatApi.getServiceUser(userId)
        .then(response => {
            setNewPassword(response.data.content);
        })
        .catch(e => {
            console.log(e);
        })
    }

    const setNewPassword = (user: IServiceUserContent) => {
        if (resetPasswordUser.newPassword === resetPasswordUser.confirmNewPassword) {
            if (user) {
                if (user.data_raw) {
                    if (user.data_raw.hash) {
                        user.data_raw.hash = resetPasswordUser.newPassword;
                    }
                }
                
                planEatApi.postServiceUser(user)
                .then(_ => {
                    loginAfterReset(user.id, resetPasswordUser.newPassword)
                })
                .catch(e => {
                    extractErrorMessage(e, "Failed updating password")
                })
            }
        } else{
            toast.error("Password did'nt match")
        }
    }

    function loginAfterReset(userId: string, newPassword: string){
        var credentials: ILogin = {
            'userId': userId,
            'password': newPassword
        };
        planEatApi.postLogin(credentials)
        .then(response => {
            localStorage.setItem("token",response.data.token)
            toast.success('Password was successfully changed')
            redirectAfterReset(userId)
        })
        .catch((e) => {
            extractErrorMessage(e, "Failed updating password")
        })
    }

    // Users without an eater group must complete sign up info first
    function redirectAfterReset(userId: string){
        planEatApi.getUsers()
        .then(response => {
            const planEatUser = response.data.find(user => user.content.applicationUserId === userId)
            history.push(planEatUser?.content.eaterGroupId ? "/booking" : "/signUpInfo")
        })
        .catch(() => {
            history.push("/booking")
        })
    }

    const handleChange = (prop: keyof IResetPasswordUser) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setResetPasswordUser({ ...resetPasswordUser, [prop]: event.target.value });
    };

    const handleClickShowPassword = () => {
        setResetPasswordUser({ ...resetPasswordUser, showPassword: !resetPasswordUser.showPassword });
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleEnterDown = (e: KeyboardEvent) => {
        if(e.key=== "Enter"){
            postToken()
        }
    }

    return (
        <div>
            <div className={classes.topbarContainer}>
                <div>
                    <img src={icon_backButton} alt="backButton" onClick={() => { history.push('') }} style={{ cursor: 'pointer' }} />
                </div>
            </div>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <div className={classes.paper}>
                <Logo variant='normal' />   
                    <div className={classes.title}>
                        Reset password
                    </div>
                    <div className={classes.inputFieldContainer}>
                        <FormControl
                            margin="normal"
                            fullWidth>
                            <InputLabel htmlFor="standard-adornment-password">Password</InputLabel>
                            <Input
                                id="standard-adornment-password"
                                type={resetPasswordUser.showPassword ? 'text' : 'password'}
                                value={resetPasswordUser.newPassword}
                                onChange={handleChange('newPassword')}
                                onKeyDown={(e) => handleEnterDown(e)}
                                endAdornment=
                                {
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            size="small"
                                        >
                                            {resetPasswordUser.showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        <FormControl
                            margin="normal"
                            fullWidth>
                            <InputLabel htmlFor="standard-adornment-password">Confirm Password</InputLabel>
                            <Input
                                id="standard-adornment-password"
                                type={resetPasswordUser.showPassword ? 'text' : 'password'}
                                value={resetPasswordUser.confirmNewPassword}
                                onChange={handleChange('confirmNewPassword')} 
                                onKeyDown={(e) => handleEnterDown(e)}/>
                        </FormControl>
                    </div>
                    <Button
                        fullWidth
                        variant="contained"
                        className={classes.sendEmailButton}
                        onClick={() => postToken()}
                        onKeyDown={(e) => handleEnterDown(e)}
                    >
                        Update Password
                    </Button>
                    <Grid
                        container
                        direction="column"
                        justifyContent="space-around"
                        alignItems="center"
                        className={classes.loginContainer}
                    >
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Link href="/" variant="body2" color="inherit" onClick={() => { history.push('forgotLogin') }}>
                                Already have an account? <b>Login</b>
                            </Link>
                        </Grid>
                    </Grid>
                </div>
            </Container>
        </div>
    );
}